import React from 'react';

// CloudAyn WordPress plugin download + install steps. Shared by asset setup
// and the guided onboarding flow.
const WordPressPluginCard: React.FC = () => (
                      <div>
                        <div className="d-flex align-items-start gap-4 mb-4 p-4 rounded" style={{ background: '#f8f9ff', border: '1px solid #e0e3ff' }}>
                          <div style={{ fontSize: 48, color: '#21759b', lineHeight: 1 }}>
                            <i className="bi bi-wordpress"></i>
                          </div>
                          <div>
                            <h5 className="fw-bold mb-1">CloudAyn WordPress Plugin</h5>
                            <p className="text-muted mb-3" style={{ fontSize: '0.9rem' }}>
                              Install our plugin to automatically inject the tracking script, monitor your WordPress site, and view reports directly in your WP admin dashboard.
                            </p>
                            <a
                              href={`${(process.env.REACT_APP_API_URL || 'https://api.cloudayn.com/api').replace('/api', '')}/wordpress-plugin/cloudayn.zip`}
                              download="cloudayn.zip"
                              className="btn btn-primary"
                            >
                              <i className="bi bi-download me-2"></i>
                              Download Plugin (v1.3.0)
                            </a>
                          </div>
                        </div>

                        <h6 className="fw-semibold mb-3">Installation Steps</h6>
                        <ol className="text-muted" style={{ paddingLeft: 20, lineHeight: 2 }}>
                          <li>Download the plugin zip file above.</li>
                          <li>In your WordPress admin, go to <strong>Plugins → Add New → Upload Plugin</strong>.</li>
                          <li>Select the downloaded <code>cloudayn.zip</code> and click <strong>Install Now</strong>.</li>
                          <li>Activate the plugin.</li>
                          <li>Go to <strong>CloudAyn → Settings</strong> and enter your email to connect your site automatically via OTP.</li>
                        </ol>

                        <div className="alert alert-success mt-3 mb-0">
                          <i className="bi bi-check-circle me-2"></i>
                          The plugin auto-injects your tracking code and links to your CloudAyn account — no manual code editing needed.
                        </div>
                      </div>
);

export default WordPressPluginCard;
